import { render, staticRenderFns } from "./TabItemCard.vue?vue&type=template&id=111cdd26&scoped=true"
import script from "./TabItemCard.vue?vue&type=script&lang=js"
export * from "./TabItemCard.vue?vue&type=script&lang=js"
import style0 from "./TabItemCard.vue?vue&type=style&index=0&id=111cdd26&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111cdd26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('111cdd26')) {
      api.createRecord('111cdd26', component.options)
    } else {
      api.reload('111cdd26', component.options)
    }
    module.hot.accept("./TabItemCard.vue?vue&type=template&id=111cdd26&scoped=true", function () {
      api.rerender('111cdd26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/evaluators/components/TabItemCard.vue"
export default component.exports